import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { ActionModalSchema, Context, Transitions } from "../../types"
import { saveCancelModalState } from "../manageModals"

export const addModalState: StateNodeConfig<
  Context,
  ActionModalSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ openAddModal: true }),
  exit: assign<Context>({ openAddModal: false }),
  ...saveCancelModalState(
    "#ManageUserModules.classes_page.loading",
    "addClass",
    {
      cancelTarget: "#ManageUserModules.classes_page.idle",
      loadingState: "add",
      onSuccess: (ctx, _evt) => ({
        snackbar: {
          message: `Successfully added ${ctx.snackbarMessageInfo}`,
          withUndo: false,
          error: false
        }
      }),
      onError: (ctx, _evt) => ({
        snackbar: {
          message: `An error occurred while trying to add class ${ctx.snackbarMessageInfo}. Please try again. If the error persists, contact support for help.`,
          withUndo: false,
          error: true
        }
      })
    }
  )
}
